import { browser } from '$app/environment';
import { Page } from '$lib/utils/page';
import { pageConditions } from './__config/conditions';
import { policy, policyExceptionHandler } from './-policy';

export const prerender = true;

/**
 * Loads the page data
 * @returns {Promise<{page: Page} | undefined>} - The page data
 */
export async function load() {
	const metadata = {
		link: [
			{
				href: 'https://www.abcmouse.com/learn/download-app',
				rel: 'canonical'
			}
		]
	};
	if (browser) {
		const page = new Page({
			conditions: pageConditions,
			metadata,
			policies: { policy, policyExceptionHandler },
			routePath: '/download-app'
		});
		return {
			page
		};
	}
}
